(() => {
  const node = document.getElementById('jl-ip-language-config');
  const form = document.getElementById('jl-ip-language-form');
  if (!node || !form || document.documentElement.dataset.jlIpLanguageReady) return;
  document.documentElement.dataset.jlIpLanguageReady = 'true';
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  if (!config.enabled) return;
  const languages = config.languages || [];
  const resolve = code => languages.find(language => language.toLowerCase() === String(code).toLowerCase());
  const english = resolve('en');
  const chinese = resolve('zh-CN') || languages.find(language => /^zh(?:-|$)/i.test(language));
  if (!english) return;
  const preferenceKey = 'jl-language-preference-v1';
  const geoKey = 'jl-ip-country-v1';
  const hopKey = 'jl-language-hop-v1';
  let changed = false;
  let controller;
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
  const remember = value => {
    if (!resolve(value)) return;
    changed = true;
    controller?.abort();
    write('localStorage', preferenceKey, resolve(value));
  };
  document.addEventListener('change', event => {
    if (event.target.matches?.('select[name="language_code"]') && event.target.form !== form) remember(event.target.value);
  }, true);
  document.addEventListener('submit', event => {
    const target = event.target;
    if (target === form || target.querySelector?.('[name="form_type"]')?.value !== 'localization') return;
    const value = target.querySelector('[name="language_code"]')?.value;
    if (value) remember(value);
  }, true);
  const root = (config.root || '/').replace(/\/+$/, '') || '/';
  const segment = location.pathname.split('/')[1].toLowerCase();
  const explicit = root !== '/' || languages.some(language => segment === language.toLowerCase()) || segment === 'zh';
  if (explicit || /\b(bot|crawler|spider)\b/i.test(navigator.userAgent)) return;
  const switchTo = language => {
    if (changed || !resolve(language) || language === config.current) return;
    const returnPath = location.pathname + location.search + location.hash;
    const hop = language + ':' + returnPath;
    if (read('sessionStorage', hopKey) === hop) return;
    form.querySelector('[name="language_code"]').value = language;
    form.querySelector('[name="return_to"]').value = returnPath;
    write('sessionStorage', hopKey, hop);
    form.requestSubmit();
  };
  const saved = resolve(read('localStorage', preferenceKey));
  if (saved) { switchTo(saved); return; }
  let cached;
  try { cached = JSON.parse(read('sessionStorage', geoKey)); } catch {}
  if (cached?.country && Date.now() - cached.at < 6 * 60 * 60 * 1000) {
    switchTo(cached.country === 'CN' && chinese ? chinese : english);
    return;
  }
  controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 1800);
  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=true', { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } })
    .then(response => { if (!response.ok) throw new Error(); return response.json(); })
    .then(data => {
      const country = data?.detected_values?.country?.handle;
      if (typeof country !== 'string' || !/^[A-Z]{2}$/i.test(country) || changed) return;
      write('sessionStorage', geoKey, JSON.stringify({ country: country.toUpperCase(), at: Date.now() }));
      switchTo(country.toUpperCase() === 'CN' && chinese ? chinese : english);
    })
    .catch(() => {})
    .finally(() => clearTimeout(timeout));
})();
